import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Popup from '../Popup';
import '../../styles/insertTablePopup.scss';
import InputBox from '../InputBox';
import { useTranslation } from 'react-i18next';
import FooterActionsButtons from '../../widgets/popup/FooterActionsButtons';
import { getImageSrc } from '../../helper/imageBlobCache';
var InsertTablePopup = function (props) {
    var _a = props.id, id = _a === void 0 ? 'insertTable' : _a, onClick = props.onClick, isOpen = props.isOpen, setIsOpen = props.setIsOpen;
    var t = useTranslation().t;
    var _b = useState(''), rows = _b[0], setRows = _b[1];
    var _c = useState(''), columns = _c[0], setColumns = _c[1];
    var MAX = 20;
    var parseInput = function (val) {
        var digits = val.replace(/\D/g, '');
        if (!digits)
            return '';
        return String(parseInt(digits, 10));
    };
    // Firefox allows typing letters in type="number" inputs unlike Chrome/Safari.
    // Block non-digit keys at the keyboard level for consistent cross-browser behavior.
    var numericKeyDown = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
            return;
        }
        if (['Backspace', 'Delete', 'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key))
            return;
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };
    var rowsNum = parseInt(rows, 10);
    var colsNum = parseInt(columns, 10);
    var isOverLimit = (rowsNum > 0 && rowsNum > MAX) || (colsNum > 0 && colsNum > MAX);
    var isValid = !!(rowsNum && colsNum) && !isOverLimit;
    var handleSubmit = function () {
        if (!isValid)
            return;
        onClick && onClick(id, { rowsNum: rowsNum, colsNum: colsNum });
        setIsOpen(false);
    };
    return (_jsx(Popup, { isOpen: isOpen, onClose: function () {
            setIsOpen(false);
        }, className: "tablePopup", ariaLabelledBy: "insertTableTitle", children: _jsxs("div", { className: "tableContainer", role: "form", "aria-labelledby": "insertTableTitle", children: [_jsx("h2", { id: "insertTableTitle", className: "text title", children: t('text.insertTable') }), _jsx("p", { id: "insertTableHint", className: "srOnly", children: t('text.insertTableHint', { max: MAX }) }), _jsxs("div", { className: "tableForm", children: [_jsxs("div", { className: "tableColumn", children: [_jsxs("label", { htmlFor: "columnInput_input", className: "text", children: [t('text.columns'), " (1-", MAX, "):"] }), _jsx(InputBox, { id: "columnInput", name: "columns", type: "text", inputMode: "numeric", min: 1, max: MAX, value: columns, onInput: function (_id, val) {
                                        setColumns(parseInput(val));
                                    }, onChange: function (_id, eventType, val) {
                                        if (eventType === 'blur') {
                                            setColumns(parseInput(val));
                                        }
                                    }, onKeyDown: numericKeyDown, defaultCSS: "inputField", ariaLabel: t('text.columnsInputAriaLabel', { max: MAX }), ariaDescribedBy: "insertTableHint" })] }), _jsxs("div", { className: "tableRow", children: [_jsxs("label", { htmlFor: "rowInput_input", className: "text", children: [t('text.rows'), " (1-", MAX, "):"] }), _jsx(InputBox, { id: "rowInput", name: "rows", type: "text", inputMode: "numeric", min: 1, max: MAX, value: rows, onInput: function (_id, val) {
                                        setRows(parseInput(val));
                                    }, onChange: function (_id, eventType, val) {
                                        if (eventType === 'blur') {
                                            setRows(parseInput(val));
                                        }
                                    }, onKeyDown: numericKeyDown, defaultCSS: "inputField", ariaLabel: t('text.rowsInputAriaLabel', { max: MAX }), ariaDescribedBy: "insertTableHint" })] }), _jsx("p", { className: "limitNote".concat(isOverLimit ? '' : ' hidden'), children: t('text.tableLimit', { max: MAX }) }), _jsx(FooterActionsButtons, { disableDoneBtn: !isValid, onActionBtnClick: function (type) {
                                if (type === 'done') {
                                    handleSubmit();
                                }
                                else {
                                    setIsOpen(false);
                                }
                            } })] }), _jsx("img", { className: "bgImage", src: getImageSrc('./assets/images/popupColorPatch.svg'), alt: "", "aria-hidden": "true" })] }) }));
};
export default InsertTablePopup;
